import React from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { ProtectedRoute } from "./components/common/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AssetRegister from "./pages/assets/AssetRegister";
import WorkOrderList from "./pages/workorders/WorkOrderList";
import MaintenanceRequests from "./pages/workorders/MaintenanceRequests";
import PMScheduler from "./pages/pm/PMScheduler";
import SparePartsInventory from "./pages/spareparts/SparePartsInventory";
import Reports from "./pages/reports/Reports";
import Administration from "./pages/admin/Administration";

function withLayout(children: React.ReactNode) {
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<ProtectedRoute>{withLayout(<Dashboard />)}</ProtectedRoute>} />

      <Route
        path="/assets"
        element={<ProtectedRoute requirePermissions={["*", "asset:view", "asset:manage"]}>{withLayout(<AssetRegister />)}</ProtectedRoute>}
      />

      <Route path="/work-orders" element={<ProtectedRoute>{withLayout(<WorkOrderList />)}</ProtectedRoute>} />

      <Route path="/requests" element={<ProtectedRoute>{withLayout(<MaintenanceRequests />)}</ProtectedRoute>} />

      <Route
        path="/pm-scheduler"
        element={<ProtectedRoute requirePermissions={["*", "pm:manage"]}>{withLayout(<PMScheduler />)}</ProtectedRoute>}
      />

      <Route
        path="/spare-parts"
        element={
          <ProtectedRoute requirePermissions={["*", "inventory:issue", "inventory:receive", "inventory:adjust"]}>
            {withLayout(<SparePartsInventory />)}
          </ProtectedRoute>
        }
      />

      <Route
        path="/reports"
        element={<ProtectedRoute requirePermissions={["*", "reports:view"]}>{withLayout(<Reports />)}</ProtectedRoute>}
      />

      <Route
        path="/admin"
        element={
          <ProtectedRoute requirePermissions={["*", "user:manage", "master:manage"]}>{withLayout(<Administration />)}</ProtectedRoute>
        }
      />

      <Route path="*" element={<ProtectedRoute>{withLayout(<Dashboard />)}</ProtectedRoute>} />
    </Routes>
  );
}
